// extracted by mini-css-extract-plugin
export default {"root":"styles_root__evol9","number":"styles_number__va2nP","numberAnimation":"styles_numberAnimation__G5B1H","quantity-label-update":"styles_quantity-label-update__hAFxp"};